import { FinancingSerializer } from './FinancingSerializer';
import { StockSerializer } from './StockSerializer';

const textService = (service) => {
  if (!service) {
    return;
  }
  if (service.ArtNombre.includes('Garantía')) {
    // eslint-disable-next-line consistent-return
    return ['Incluir garantía de pantalla', 'Incluye garantía de pantalla', 'No incluye garantía de pantalla', 'Agregar garanatía', 'Quitar garantía', '¿Desea incluir la garantía adicional de pantalla?', 'No', 'La garantía adicional de pantalla del equipo tiene un costo de', ''];
  }
  if (service.ArtNombre.includes('Instalación')) {
    // eslint-disable-next-line consistent-return
    return ['Incluir instalación de equipo', 'Incluye instalación de equipo', 'No incluye instalación de equipo', 'Agregar instalación', 'Quitar instalación', '¿Desea incluir el servicio de instalación del equipo?', 'No, yo lo instalo', 'La instalación del equipo tiene un costo de', 'Incluir instalación de equipo'];
  }
};

class BaseProductSerializer {
  static deSerialize(data) {
    const financingData = data.PrecioVigente || [];
    const brand = data.Marca ? (data.Marca.MarNombre || null) : null;
    const [coverImageData, ...productImageData] = (data.ArticulosImagenes || []);
    return {
      ableToSell: data.HabilitadoVenta || false,
      brand,
      code: data.ArtCodigo,
      coverImage: (coverImageData || {}).AImImagen || null,
      financing: FinancingSerializer.deSerialize(financingData),
      id: String(data.ArtId),
      inWeb: data.ArtEnWeb,
      isService: data.ArtEsServicio || false,
      images: productImageData.map(imageData => (imageData || {}).AImImagen || null),
      name: data.ArtNombre,
      condition: data.ArtCondicion,
      stockLevel: StockSerializer.deSerialize(data.Stock),
      label: data.DestaqueWeb || null,
      labelColor: data.DestaqueWebColor || null,
      notAbleToSellString: data.ArticuloVienenTextoWeb || null,
      maxAmountToSell: data.ArtCantMaxVentaWeb || null,
      inUse: data.ArtEnUso !== undefined ? data.ArtEnUso : true,
      specificId: data.IdEspecifico || null,
      textsService: textService(data.Instalacion),
    };
  }
}

export { BaseProductSerializer };



// WEBPACK FOOTER //
// ./src/networking/serializers/BaseProductSerializer.js